import config from '../config';
import { validationLat, validationLng } from '../lib/tools';

const { mapDefaultLat, mapDefaultLng } = config;
const defaultLat = Number(mapDefaultLat);
const defaultLng = Number(mapDefaultLng);

const appInitialState = {
  openLocationSearchMap: false,
  locationSearchData: {
    lat: defaultLat,
    lng: defaultLng,
    address: '',
    center: {
      lat: defaultLat,
      lng: defaultLng,
    },
  },
};

export default (state = appInitialState, action) => {
  switch (action.type) {
    case 'OPEN_LOCATION_SEARCH': {
      const latLng = action.params;
      const openLocationSearchMap = true;
      const check =
        latLng.lat !== null &&
        latLng.lng !== null &&
        latLng.lat !== '' &&
        latLng.lng !== '' &&
        !validationLat(latLng.lat) &&
        !validationLng(latLng.lng);
      const lat = check ? Number(latLng.lat) : defaultLat;
      const lng = check ? Number(latLng.lng) : defaultLng;
      const center = { lat, lng };
      const locationSearchData = {
        ...state.locationSearchData,
        lat,
        lng,
        center,
      };
      return { ...state, openLocationSearchMap, locationSearchData };
    }
    case 'CLOSE_LOCATION_SEARCH': {
      return { ...appInitialState };
    }
    case 'CHANGE_POINT_LOCATION_SEARCH': {
      const latLng = action.params;
      const check = latLng && latLng.lat !== null && latLng.lng !== null;
      const lat =
        (check && Math.floor(latLng.lat * 10000000) / 10000000) || null;
      const lng =
        (check && Math.floor(latLng.lng * 10000000) / 10000000) || null;
      const locationSearchData = (check && {
        ...state.locationSearchData,
        lat,
        lng,
      }) || { ...state.locationSearchData };
      return { ...state, locationSearchData };
    }
    case 'INPUT_SEARCH_LOCATION_SEARCH': {
      const address = action.params.address || '';
      const locationSearchData = { ...state.locationSearchData, address };
      return { ...state, locationSearchData };
    }
    case 'SUCCESS_API_GET_GEOCODE': {
      const result = action.payload.result || false;
      const { lat, lng } = action.payload;
      const center = { lat, lng };
      const locationSearchData = (result && {
        ...state.locationSearchData,
        lat,
        lng,
        center,
      }) || { ...state.locationSearchData };
      return { ...state, locationSearchData };
    }
    default:
      return state;
  }
};
